// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file giftcard_transaction.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file giftcard_transaction.proto.
 */
export const file_giftcard_transaction: GenFile = /*@__PURE__*/
  fileDesc("ChpnaWZ0Y2FyZF90cmFuc2FjdGlvbi5wcm90bxILZ3JwYy5hcGkudjEinwMKE0dpZnRjYXJkVHJhbnNhY3Rpb24SRgoEdHlwZRgBIAEoDjI4LmdycGMuYXBpLnYxLkdpZnRjYXJkVHJhbnNhY3Rpb24uR2lmdGNhcmRUcmFuc2FjdGlvblR5cGUSDgoGYW1vdW50GAIgASgFEhAKCGN1cnJlbmN5GAMgASgJEgwKBGRhdGUYBCABKAMSEwoLZ2lmdGNhcmRfaWQYBSABKAMSFQoNZ2lmdGNhcmRfY29kZRgGIAEoCRIlCh1naWZ0Y2FyZF9pc3N1ZWRfYnlfYWNjb3VudF9pZBgHIAEoAxInCh9naWZ0Y2FyZF9pc3N1ZWRfYnlfYWNjb3VudF9uYW1lGAggASgJEh4KFmV4ZWN1dGVkX2J5X2FjY291bnRfaWQYCSABKAMSIAoYZXhlY3V0ZWRfYnlfYWNjb3VudF9uYW1lGAogASgJIlIKF0dpZnRjYXJkVHJhbnNhY3Rpb25UeXBlEggKBE5PTkUQABIICgRTQUxFEAESBwoDRkVFEAISCgoGUkVERUVNEAMSDgoKRVhQSVJBVElPThAEQgZaBC47cGJiBnByb3RvMw");

/**
 * GiftcardTransaction
 *
 * @generated from message grpc.api.v1.GiftcardTransaction
 */
export type GiftcardTransaction = Message<"grpc.api.v1.GiftcardTransaction"> & {
  /**
   * @generated from field: grpc.api.v1.GiftcardTransaction.GiftcardTransactionType type = 1;
   */
  type: GiftcardTransaction_GiftcardTransactionType;

  /**
   * @generated from field: int32 amount = 2;
   */
  amount: number;

  /**
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: int64 date = 4;
   */
  date: bigint;

  /**
   * @generated from field: int64 giftcard_id = 5;
   */
  giftcardId: bigint;

  /**
   * @generated from field: string giftcard_code = 6;
   */
  giftcardCode: string;

  /**
   * @generated from field: int64 giftcard_issued_by_account_id = 7;
   */
  giftcardIssuedByAccountId: bigint;

  /**
   * @generated from field: string giftcard_issued_by_account_name = 8;
   */
  giftcardIssuedByAccountName: string;

  /**
   * @generated from field: int64 executed_by_account_id = 9;
   */
  executedByAccountId: bigint;

  /**
   * @generated from field: string executed_by_account_name = 10;
   */
  executedByAccountName: string;
};

/**
 * Describes the message grpc.api.v1.GiftcardTransaction.
 * Use `create(GiftcardTransactionSchema)` to create a new message.
 */
export const GiftcardTransactionSchema: GenMessage<GiftcardTransaction> = /*@__PURE__*/
  messageDesc(file_giftcard_transaction, 0);

/**
 * @generated from enum grpc.api.v1.GiftcardTransaction.GiftcardTransactionType
 */
export enum GiftcardTransaction_GiftcardTransactionType {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: SALE = 1;
   */
  SALE = 1,

  /**
   * @generated from enum value: FEE = 2;
   */
  FEE = 2,

  /**
   * @generated from enum value: REDEEM = 3;
   */
  REDEEM = 3,

  /**
   * @generated from enum value: EXPIRATION = 4;
   */
  EXPIRATION = 4,
}

/**
 * Describes the enum grpc.api.v1.GiftcardTransaction.GiftcardTransactionType.
 */
export const GiftcardTransaction_GiftcardTransactionTypeSchema: GenEnum<GiftcardTransaction_GiftcardTransactionType> = /*@__PURE__*/
  enumDesc(file_giftcard_transaction, 0, 0);

